import {createContext, useContext} from 'react'

import type {ThreadPreferences} from '#/state/queries/preferences/useThreadPreferences'

export type ThreadPreferencesContextType = Pick<
  ThreadPreferences,
  'sort' | 'view' | 'setSort' | 'setView'
>

const ThreadPreferencesContext = createContext<
  ThreadPreferencesContextType | undefined
>(undefined)

export function useThreadPreferencesContext() {
  return useContext(ThreadPreferencesContext)
}

export const ThreadPreferencesContextProvider =
  ThreadPreferencesContext.Provider
